import config from '../services/config';
import winston from 'winston';
import { isAxiosError } from './typeguards';

const logger = winston.createLogger({
    defaultMeta: {
        IMAGE_VERSION: config.IMAGE_VERSION,
    },
    transports: [new winston.transports.Console()],
});

export const processError = (e: Error | null, meta?: { errorMessage?: string; url?: string; [key: string]: any }) => {
    const { errorMessage, ...other } = meta || {};
    const error =
        e && isAxiosError(e)
            ? {
                  axiosError: true,
                  message: e.message,
                  code: e.code,
                  responseData: e.response?.data,
                  responseCode: e.response?.status,
              }
            : e;
    const defaultMeta =
        e && isAxiosError(e)
            ? {
                  url: e.config?.url,
                  method: e.config?.method,
              }
            : {};
    logger.error(errorMessage || error?.message || '', { error, ...defaultMeta, ...other });
};

export { logger };
